import React, { FC } from 'react';
import { header, headerTopBorder } from './styles';
import { ArrowCircleRightIcon } from '@fronton/icons-react';
import { LinkButton, IconButton } from 'fronton-react';
import { cx } from 'linaria';
import { analyticsUtils } from 'utils';
import { useSelector } from 'react-redux';
import { isProductSet, isWebSellable } from 'features/product-info';
import { useTranslation } from 'react-i18next';
import { getIsOnlineOnly, getStocksInStores } from 'features/goods-supply';

export const DATA_QA_RELATED_SERVICES_BUTTON = 'related-services-button-uslugi_mf-pdp';
export const DATA_QA_RELATED_SERVICES_ICON = 'related-services-icon-uslugi_mf-pdp';

const clickHandler = (isSet: boolean) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementBlock: isSet ? 'komplektyDetail / services' : 'productDetail / services',
    elementName: 'toUslugi',
    elementText: 'Помощь мастера',
    elementType: 'button',
  });
};

export const RelatedServiceButton: FC = () => {
  const { t } = useTranslation();

  const stocks = useSelector(getStocksInStores);
  const isSellable = useSelector(isWebSellable);
  const isOnlineOnly = useSelector(getIsOnlineOnly);
  const isSet = useSelector(isProductSet);

  const hasEmptyStocksRecords = !stocks.some((stock) => stock.stockValue > 0);
  const hasDisplaySample = hasEmptyStocksRecords && stocks.some((stock) => stock.displaySample);
  const isRenderTopBorder = !hasDisplaySample && isSellable && (isOnlineOnly || hasEmptyStocksRecords);

  return (
    <div className={cx(header, isRenderTopBorder ? headerTopBorder : null)}>
      <LinkButton
        href="/uslugi/"
        target="_blank"
        data-qa={DATA_QA_RELATED_SERVICES_BUTTON}
        size="s"
        onClick={() => clickHandler(isSet)}
        variant="accent"
      >
        {t('related-services.button')}
      </LinkButton>
      <IconButton
        href="/uslugi/"
        target="_blank"
        data-qa={DATA_QA_RELATED_SERVICES_ICON}
        label={t('related-services.button')}
        onClick={() => clickHandler(isSet)}
        size="l"
      >
        <ArrowCircleRightIcon type="outline" size="l" color="text-primary" />
      </IconButton>
    </div>
  );
};
